import { Record } from 'immutable';

const TradeInRecord = new Record({
    id: null,
    status: 0,
    leadId: 0,
    tradeInVehicle: {
        id: '',
        make: '',
        model: '',
        trim: '',
        style: '',
        year: '',
        exteriorColor: '',
        vin: '',
        odometer: '',
    },
    estimation: {
        amount: 0,
        high: 0,
        low: 0,
    },
    evaluationQuestions: {},
    profile: {
        firstname: '',
        lastname: '',
        homePhone: '',
        email: '',
    },
});

class TradeInModel extends TradeInRecord {}

export default TradeInModel;



// WEBPACK FOOTER //
// ./src/model/TradeInModel.js